import React from 'react';
import { FooterBorderContainer, FooterCellElement } from '../styled';
import { formatCell } from '../utils';
export function FooterCell({ column, footerRow }) {
    return (React.createElement(FooterCellElement, { style: Object.assign(Object.assign({}, column.style), footerRow.style) },
        React.createElement(FooterBorderContainer, null, formatCell(footerRow, column))));
}
